<template>
  <div class="bg-[#0B1529] h-screen overflow-y-auto dailyCashback">
    <van-nav-bar :title="t('menus.dailyCashbackss')" safe-area-inset-top :border="false"
      class="custom-nav-bar nav-bar-fixed sticky-nav">
      <template #left>
        <Button type="back" @click="onClickLeft" />
      </template>
    </van-nav-bar>
    <div class="px-[10px] mt-[100px] pb-[100px]">
      <div class=" h-[305px] relative rounded-t-[14px] bgcolese">
        <img :src="getAssetsFile('activity/weekMonyCenterBg.png')" alt=""
          class="w-[80%] h-[200px] absolute top-[-20px] left-[30px] z-[1] transform -translate-y-1/5 rotating-image">
        <div class="w-[71px] h-[71px] absolute top-0 left-0"
          :style="{ backgroundImage: `url(${dailyBg})`, backgroundSize: '100% 100%', backgroundRepeat: 'no-repeat' }">
          <div class="w-full h-full relative flex items-center justify-center">
            <div
              class="relative left-1/3 top-0 w-full text-[#000000] text-[12px] text-center transform -rotate-45 -translate-y-1/2 -translate-x-1/2">
              {{ t('weekCashback.days') }}
            </div>
          </div>
        </div>
        <div class="w-[170px] h-[150px] absolute left-1/2 -translate-x-1/2 top-[10px] -translate-y-1/3 "
          style="z-index: 10;">
          <img class="w-full h-full" :src="monyBg" alt="" srcset="">
        </div>
        <div class="w-full h-[201px] absolute bottom-0 left-0">
          <div class="flex justify-center mt-[10px]">
            <div class="grid grid-cols-4 gap-[10px]">
              <div class="w-[35px] h-[44px] flex items-center justify-center"
                :style="{ backgroundImage: `url(${timeItemBg})`, backgroundSize: '100% 100%', backgroundRepeat: 'no-repeat' }">
                <div class="text-[8px] text-[#FFFFFF]">
                  <div class="text-[15px] font-bold text-center">{{ countdown.days }}</div>
                  <div class="mt-[8px] text-center">{{ t('weekCashback.days') }}</div>
                </div>
              </div>
              <div class="w-[35px] h-[44px] flex items-center justify-center"
                :style="{ backgroundImage: `url(${timeItemBg})`, backgroundSize: '100% 100%', backgroundRepeat: 'no-repeat' }">
                <div class="text-[8px] text-[#FFFFFF]">
                  <div class="text-[15px] font-bold text-center">{{ countdown.hours }}</div>
                  <div class="mt-[8px] text-center">{{ t('weekCashback.hours') }}</div>
                </div>
              </div>
              <div class="w-[35px] h-[44px] flex items-center justify-center"
                :style="{ backgroundImage: `url(${timeItemBg})`, backgroundSize: '100% 100%', backgroundRepeat: 'no-repeat' }">
                <div class="text-[8px] text-[#FFFFFF]">
                  <div class="text-[15px] font-bold text-center">{{ countdown.minutes }}</div>
                  <div class="mt-[8px] text-center">{{ t('weekCashback.min') }}</div>
                </div>
              </div>
              <div class="w-[35px] h-[44px] flex items-center justify-center"
                :style="{ backgroundImage: `url(${timeItemBg})`, backgroundSize: '100% 100%', backgroundRepeat: 'no-repeat' }">
                <div class="text-[8px] text-[#FFFFFF]">
                  <div class="text-[15px] font-bold text-center">{{ countdown.seconds }}</div>
                  <div class="mt-[8px] text-center">{{ t('weekCashback.sec') }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="mt-[17px] grid grid-cols-2 gap-[10px] px-[12px]">
            <div
              class="bg-[#211A66] border-[2px] border-solid border-[#5764FC] rounded-[15px] h-[77px] flex items-end justify-center">
              <div class="py-[10px]">
                <div class="flex text-[#E1D9FD] items-end justify-center">
                  <div class="text-[12px] mr-[7px]">{{ VITE_symbol }}</div>
                  <div class="text-[15px] font-bold color-[#FFD744]">{{ weekList.loss || 0 }}</div>
                </div>
                <div class="w-full text-[12px] text-[#E1D9FD] text-center mt-[17px] font-bold">
                  {{ t('weekCashback.myLosses') }}
                </div>
              </div>

            </div>
            <div
              class="bg-[#211A66] border-[2px] border-solid border-[#5764FC] rounded-[15px] h-[77px] flex items-end justify-center">
              <div class="py-[10px]">
                <div class="flex text-[#E1D9FD] items-end justify-center">
                  <div class="text-[12px] mr-[7px]">{{ VITE_symbol }} </div>
                  <div class="text-[15px] font-bold color-[#FFD744]">{{ weekList.reward || 0 }}</div>
                </div>
                <div class="w-full text-[12px] text-[#E1D9FD] text-center mt-[17px]  font-bold">
                  {{ t('weekCashback.collectible') }}
                </div>
              </div>

            </div>
          </div>
          <div class="mt-[34px] flex justify-around text-[#9CB6DF] text-[12px]">
            <div>{{ t('weekCashback.ValorDaPerda') }}</div>
            <div>{{ t('weekCashback.collectible') }}</div>
          </div>
        </div>
      </div>
      <div class="px-[12px] py-[6px] bg-[#111542]">
        <div v-for="(item, index) in weekList.rewardConfig" :key="item"
          class="w-full  h-[45px] flex items-center bg-gradient-to-r from-[#4A62DE] to-[#206F8C] rounded-[15px] h-[100px] my-[15px]">
          <div class="w-1/2 flex items-center justify-center">
            <div class="flex items-center justify-center">
              <div class="w-[16px] h-[16px] mr-[5px] color-[#ffffff]">{{ VITE_symbol }}</div>
              <div class="text-[15px] text-[#FFFFFF] font-bold">{{ item.value || 0 }}</div>
            </div>
          </div>
          <div class="w-1/2 flex items-center justify-center">
            <div class="text-[15px] text-[#FFD744] font-bold">{{ numberFormat(item.ratio * 100, { minDecimals: 2 }) }}%
            </div>
          </div>
        </div>
      </div>
      <div class="pt-[80px] bg-[#111542] borders">
        <div class="flex justify-center items-center text-[#FFFFFF] text-[15px]">
          <img class="w-[16px] h-[11px]" :src="titleLeftIcon" alt="">
          <span class="mx-[8px] font-bold">{{ t('weekCashback.activityDescription') }}</span>
          <img class="w-[16px] h-[11px]" :src="titleRightIcon" alt="">
        </div>
        <div class="mt-[18px]">
          <img class="w-[100%] h-[1px]" :src="divider" alt="">
        </div>
        <div class="px-[30px] pb-[78px] text-[#81AEE6] text-[12px] lh-[28px] ">
          <p>
            {{ t('weekCashback.rule1') }}
          </p>
          <p>
            {{ t('weekCashback.rule2') }}
          </p>
          <p>
            {{ t('weekCashback.rule3') }}
          </p>
          <p>
            {{ t('weekCashback.rule4') }}
          </p>
          <p>
            {{ t('weekCashback.rule5') }}
          </p>

        </div>
      </div>
    </div>

    <!-- 固定按钮 - 响应式宽度 -->
    <div class="fixed bottom-[20px] left-[10px] right-[10px] z-50">
      <div class="w-full md:w-[330px] mx-auto h-[60px] flex justify-center items-center"
        :style="{ backgroundImage: `url(${buttonBg})`, backgroundSize: '100% 100%', backgroundRepeat: 'no-repeat' }"
        @click="handleButtonClick(12)">
        <!-- 内层渐变盒子 -->
        <div
          class="w-[calc(100%-20px)] h-[calc(100%-20px)] flex justify-center items-center rounded-lg transition-all duration-300 relative overflow-hidden"
          :class="weekList?.claimed ? 'button-highlight' : 'button-dim'">
          <div class="text-[#203070] text-[15px] font-bold relative z-10">
            {{ t('weekCashback.receive') }}
          </div>
          <!-- 镜片效果 -->
          <div v-if="weekList?.claimed" class="button-shine"></div>
        </div>
      </div>
    </div>

    <!-- RewardDialog 组件 -->
    <RewardDialog v-model:show="showRewardDialog" :amount="rewardAmount" @confirm="handleRewardConfirm" />
  </div>
</template>

<script setup lang="ts">
import { Button } from "@/components/Button"
import { ref, onMounted, onBeforeUnmount } from 'vue'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { getUserRescue, receiveRescue } from '@/api/game'
import RewardDialog from '@/components/RewardDialog.vue'
import { numberFormat } from '@/utils/formatter';
const { t } = useI18n()
const dailyBg = getAssetsFile('activity/weekDailyBg.png')
const monyBg = getAssetsFile('activity/dayMonyBg.png')
const monyCenterBg = getAssetsFile('activity/weekMonyCenterBg.png')
const timeItemBg = getAssetsFile('activity/dayTimeItemBg.png')
const Icon = getAssetsFile('activity/aweIcon.png')
const titleLeftIcon = getAssetsFile('activity/gleft.png')
const titleRightIcon = getAssetsFile('activity/gitright.png')
const divider = getAssetsFile('activity/weekDivider.png')
const buttonBg = getAssetsFile('activity/weekButton.png')
const router = useRouter()
const VITE_symbol = import.meta.env.VITE_SYMBOL
const onClickLeft = () => {
  router.back()
}

const weekList = ref({})
const countdown = ref({
  days: '00',
  hours: '00',
  minutes: '00',
  seconds: '00'
})

// RewardDialog 相关状态
const showRewardDialog = ref(false)
const rewardAmount = ref<any>({})

let countdownTimer: NodeJS.Timeout | null = null

// 计算倒计时
const calculateCountdown = (totalSeconds: number) => {
  if (totalSeconds <= 0) {
    countdown.value = {
      days: '00',
      hours: '00',
      minutes: '00',
      seconds: '00'
    }
    return
  }

  const days = Math.floor(totalSeconds / (24 * 60 * 60))
  const hours = Math.floor((totalSeconds % (24 * 60 * 60)) / (60 * 60))
  const minutes = Math.floor((totalSeconds % (60 * 60)) / 60)
  const seconds = totalSeconds % 60

  countdown.value = {
    days: days.toString().padStart(2, '0'),
    hours: hours.toString().padStart(2, '0'),
    minutes: minutes.toString().padStart(2, '0'),
    seconds: seconds.toString().padStart(2, '0')
  }
}

// 开始倒计时
const startCountdown = (totalSeconds: number) => {
  // 清除之前的定时器
  if (countdownTimer) {
    clearInterval(countdownTimer)
  }

  // 立即计算一次
  calculateCountdown(totalSeconds)

  // 设置定时器，每秒更新一次
  countdownTimer = setInterval(() => {
    totalSeconds--
    if (totalSeconds <= 0) {
      // 倒计时结束，清除定时器
      clearInterval(countdownTimer)
      countdownTimer = null
      // 重新获取数据
      fetchWeekData()
    } else {
      calculateCountdown(totalSeconds)
    }
  }, 1000)
}

// 获取周返水数据
const fetchWeekData = async () => {
  try {
    const res = await getUserRescue(12)
    weekList.value = res.data

    // 直接使用 res.data.countdown
    if (res.data?.countdown) {
      const totalSeconds = parseInt(res.data.countdown)
      if (!isNaN(totalSeconds) && totalSeconds > 0) {
        startCountdown(totalSeconds)
      }
    }
  } catch (error) {
    console.error('获取周返水数据失败:', error)
  }
}

onMounted(() => {
  fetchWeekData()
})

const handleButtonClick = async (id) => {
  if (weekList.value.claimed) {
    const res = await receiveRescue(id)
    rewardAmount.value = res.data
    showRewardDialog.value = true

  } else {
    window.$toast('Cannot claim now')
  }
}

// 处理奖励确认
const handleRewardConfirm = async () => {

  // 等待一下确保API处理完成
  await new Promise(resolve => setTimeout(resolve, 500))

  // 刷新数据
  await fetchWeekData()
}

onBeforeUnmount(() => {
  // 组件卸载时清除定时器
  if (countdownTimer) {
    clearInterval(countdownTimer)
    countdownTimer = null
  }
})
</script>

<style lang="scss" scoped>
.custom-nav-bar {
  height: 56px;
  box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.3), 0px -2px 22px 0px rgba(53, 189, 128, 0.61);

  &>* {
    height: 100%;
  }
}

.dailyCashback {
  --van-nav-bar-background: #000000;
  --van-nav-bar-text-color: #fff;
  --van-nav-bar-title-text-color: #fff;
  --van-nav-bar-icon-color: #fff;
}

.nav-bar-fixed {
  position: relative;
  z-index: 9999;
}

.sticky-nav {
  position: fixed !important;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
}

/* 添加旋转动画 */
.rotating-image {
  animation: rotate 15s linear infinite;
}

@keyframes rotate {
  from {
    transform: translateY(-20%) rotate(0deg);
  }

  to {
    transform: translateY(-20%) rotate(360deg);
  }
}

.bgcolese {
  background: linear-gradient(180deg, #424ED5, #101441 100%);
}

.borders {
  border-bottom-left-radius: 14px;
  border-bottom-right-radius: 14px;
}

/* 按钮样式 */
.button-dim {
  background: linear-gradient(90deg, #8B7355 0%, #B8A9C9 100%);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  opacity: 0.6;
}

.button-highlight {
  background: linear-gradient(90deg, #4A62DE 0%, #206F8C 100%);
  box-shadow: 0 4px 12px rgba(74, 98, 222, 0.4);
  transform: scale(1.00);
  border: 1px solid rgba(74, 98, 222, 0.5);
}

/* 镜片滑动动画 */
.button-shine {
  position: absolute;
  top: -50%;
  left: -100%;
  width: 100%;
  height: 200%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.8), transparent);
  transform: rotate(45deg);
  animation: shine 3s infinite;
  z-index: 2;
  pointer-events: none;
}

@keyframes shine {
  0% {
    left: -100%;
    opacity: 0;
  }

  5% {
    opacity: 1;
  }

  25% {
    left: 100%;
    opacity: 1;
  }

  30% {
    left: 100%;
    opacity: 0;
  }

  100% {
    left: 100%;
    opacity: 0;
  }
}
</style>

<route lang="json5">
    {
        name: 'dailyCashback',
        meta: {
            title: 'menus.dailyCashback',
            i18n: 'menus.dailyCashback'
        }
    }
</route>
